module.exports = __webpack_public_path__ + "static/media/PricingWorkspaceStep5.97e69c0d.jpg";